import { AdminMentorViewServices } from './service';

import {
    VIEW_APPLICATION_DATA,
    APPLICATION_STATUS,
    VIEW_COHORT_APPLICATION_DATA
} from '../../../../../common/constants/actionConstants';
import { toast } from "react-toastify";
// import {useHistory } from 'react-router-dom';
import swal from 'sweetalert';


import { isLoading } from '../../../../../common/dependencies/action/action';
import { AlternateEmail } from '@material-ui/icons';

export  const getViewApplicationData = (params,fromModule) => dispatch => {
    dispatch(isLoading(true))
    return getBindData(params,fromModule).then((data) => {
        //
        const { getViewApplicationData} = data;
        if (getViewApplicationData) {
            dispatch({
                type: VIEW_APPLICATION_DATA,
                payload: getViewApplicationData
            })
        }
        dispatch(isLoading(false))
    })
}

export  const getViewApplicationCohort = (params) => dispatch => {
    dispatch(isLoading(true))
    return getBindCohortApplicationCounter(params).then((data) => {
        //
        const { getCohortApplicationCounterData} = data;
        
        if (getCohortApplicationCounterData) {
            dispatch({
                type: VIEW_COHORT_APPLICATION_DATA,
                payload: getCohortApplicationCounterData
            })
        }
        dispatch(isLoading(false))
    })
}
export const updateApplicationStatus = (params) => async (dispatch) => {

    // alert(params)
    dispatch(isLoading(true))
    return updateAppStatus(params).then((data) => {
        
       
        const { updateApplicationStatus} = data;
       
        if (updateApplicationStatus) {
            // alert(updateApplicationStatus.data.applicationStatus)
            let text="";
            if(updateApplicationStatus.data.applicationStatus==="REQUESTINFO"){
                text  ="Application REQUEST INFO Sent Successfully";
            }else{
                text  ="Application "+updateApplicationStatus.data.applicationStatus+" Successfully";
            }
            swal("Success",text , 
            "success",
            {closeOnClickOutside: false}
    ).then(function(){ 
        window.close();
        })
            // toast.success("Application "+ updateApplicationStatus.data.applicationStatus+" Successfully");
            // history.goBack()
            dispatch({
                type: APPLICATION_STATUS,
                payload: updateApplicationStatus
            })
        }
        dispatch(isLoading(false))
    })
};
// export const updateApplicationStatus = (params) => async (dispatch) => {

//     // alert(params)
//     dispatch(isLoading(true))
//     return updateAppStatus(params).then((data) => {
//         
       
//         const { updateApplicationStatus} = data;
       
//         if (updateApplicationStatus) {
//             // alert(updateApplicationStatus.data.applicationStatus)
//             let text="";
//             if(updateApplicationStatus.data.applicationStatus==="REQUESTINFO"){
//                 text  ="Application REQUEST INFO Sent Successfully";
//             }else{
//                 text  ="Application "+updateApplicationStatus.data.applicationStatus+" Successfully";
//             }
//             swal("Success",text , 
//             "success",
//             {closeOnClickOutside: false}
//     );
//             // toast.success("Application "+ updateApplicationStatus.data.applicationStatus+" Successfully");
//             // history.goBack()
//             dispatch({
//                 type: APPLICATION_STATUS,
//                 payload: updateApplicationStatus
//             })
//         }
//         dispatch(isLoading(false))
//     })
// };

async function getBindData(params,fromModule) {
    const getViewApplicationData = await AdminMentorViewServices.getViewApplicationData(params,fromModule).catch(e => { return { data: [], status: false } });
  return { getViewApplicationData}
}
async function getBindCohortApplicationCounter(params) {
    const getCohortApplicationCounterData = await AdminMentorViewServices.getViewApplicationCohort(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
    return {
      getCohortApplicationCounterData,
    };
  }

async function updateAppStatus(params) {
    //
    const updateApplicationStatus = await AdminMentorViewServices.updateApplicationStatus(params).catch(e => { return { data: [], status: false } });
   return { updateApplicationStatus}
}